import { reactive } from 'vue';

export function useUrlToggler() {
  const urlIsExpanded = reactive({});

  function urlToggle(index) {
    urlIsExpanded[index] = !urlIsExpanded[index];
  }

  return {
    urlIsExpanded,
    urlToggle
  };
}